// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AllDocuments_tabs_2Sp08","spinAround":"AllDocuments_spinAround_nBASh"};